module.exports = __webpack_public_path__ + "img/Step1@2x.6f77f6cb.jpg";